(function () {
  // Sticky header
  var header = document.getElementById('header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('md-scrolled', window.scrollY > 60);
    }, { passive: true });
  }

  // Smooth scroll vers #reviews avec highlight à l'arrivée
  document.querySelectorAll('a[href="#reviews"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      var target = document.getElementById('reviews');
      if (!target) return;
      var headerHeight = (document.getElementById('header') || {}).offsetHeight || 80;
      var top = target.getBoundingClientRect().top + window.scrollY - headerHeight - 16;
      window.scrollTo({ top: top, behavior: 'smooth' });
      // Highlight à l'arrivée
      setTimeout(function () {
        target.classList.add('md-reviews-highlight');
        setTimeout(function () { target.classList.remove('md-reviews-highlight'); }, 1200);
      }, 600);
    });
  });

  // Scroll reveal
  var targets = [
    '.card-wrapper', '.service-item', '.ishi-service-item',
    '.new-blog-article', '.blog-article', '.card--article',
    '.footer-block', '.benefit-item',
  ].join(',');

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('md-visible');
        observer.unobserve(e.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

  document.querySelectorAll(targets).forEach(function (el, i) {
    el.classList.add('md-reveal');
    var mod = i % 4;
    if (mod === 1) el.classList.add('md-reveal-delay-1');
    if (mod === 2) el.classList.add('md-reveal-delay-2');
    if (mod === 3) el.classList.add('md-reveal-delay-3');
    observer.observe(el);
  });
})();
